"use client";

import { c as _c } from "react/compiler-runtime";
import Image from "next/image";
import { Col } from "react-bootstrap";
import styles from "../NFTImage.module.scss";
import NFTImageBalance from "../NFTImageBalance";
import type { BaseRendererProps } from "../types/renderer-props";
function getSrc(nft: BaseRendererProps["nft"], showThumbnail: boolean, showOriginal: boolean): string {
  if (showThumbnail) {
    return nft.thumbnail;
  } else if (nft.scaled && !showOriginal) {
    return nft.scaled;
  } else {
    return nft.image;
  }
}
export default function NFTImageRenderer(props) {
  const $ = _c(25);
  const t0 = !!props.showThumbnail;
  const t1 = !!props.showOriginal;
  let t2;
  if ($[0] !== props.nft || $[1] !== t0 || $[2] !== t1) {
    t2 = getSrc(props.nft, t0, t1);
    $[0] = props.nft;
    $[1] = t0;
    $[2] = t1;
    $[3] = t2;
  } else {
    t2 = $[3];
  }
  const src = t2;
  const shouldLazyLoad = !!props.showThumbnail || props.height === 300;
  const t3 = `mb-2 text-center d-flex align-items-center justify-content-center ${styles.imageWrapper} ${props.heightStyle} ${props.bgStyle}`;
  const t4 = shouldLazyLoad ? "lazy" : "eager";
  const t5 = !shouldLazyLoad;
  const t6 = shouldLazyLoad ? "auto" : "high";
  let t7;
  if ($[4] === Symbol.for("react.memo_cache_sentinel")) {
    t7 = {
      height: "auto",
      width: "auto",
      maxWidth: "100%",
      maxHeight: "100%"
    };
    $[4] = t7;
  } else {
    t7 = $[4];
  }
  const t8 = props.id ?? `image-${props.nft.id}`;
  let t9;
  if ($[5] !== props.nft) {
    t9 = t10 => {
      const {
        currentTarget
      } = t10;
      if (currentTarget.src === props.nft.thumbnail) {
        currentTarget.src = props.nft.scaled ? props.nft.scaled : props.nft.image;
      } else {
        if (currentTarget.src === props.nft.scaled) {
          currentTarget.src = props.nft.image;
        } else {
          if ("metadata" in props.nft) {
            currentTarget.src = props.nft.metadata.image;
          }
        }
      }
    };
    $[5] = props.nft;
    $[6] = t9;
  } else {
    t9 = $[6];
  }
  let t10;
  if ($[7] !== props.imageStyle || $[8] !== props.nft.name || $[9] !== src || $[10] !== t4 || $[11] !== t5 || $[12] !== t6 || $[13] !== t8 || $[14] !== t9) {
    t10 = <Image loading={t4} priority={t5} width="0" height="0" fetchPriority={t6} unoptimized={true} className={props.imageStyle} style={t7} id={t8} src={src} alt={props.nft.name} onError={t9} />;
    $[7] = props.imageStyle;
    $[8] = props.nft.name;
    $[9] = src;
    $[10] = t4;
    $[11] = t5;
    $[12] = t6;
    $[13] = t8;
    $[14] = t9;
    $[15] = t10;
  } else {
    t10 = $[15];
  }
  let t11;
  if ($[16] !== props.height || $[17] !== props.nft.contract || $[18] !== props.nft.id || $[19] !== props.showBalance) {
    t11 = props.showBalance && <NFTImageBalance contract={props.nft.contract} tokenId={props.nft.id} height={props.height} />;
    $[16] = props.height;
    $[17] = props.nft.contract;
    $[18] = props.nft.id;
    $[19] = props.showBalance;
    $[20] = t11;
  } else {
    t11 = $[20];
  }
  let t12;
  if ($[21] !== t10 || $[22] !== t11 || $[23] !== t3) {
    t12 = <Col xs={12} className={t3}>{t10}{t11}</Col>;
    $[21] = t10;
    $[22] = t11;
    $[23] = t3;
    $[24] = t12;
  } else {
    t12 = $[24];
  }
  return t12;
}